import { DatePipe } from "@angular/common";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule, Routes } from "@angular/router";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { JwtHelper } from "angular2-jwt/angular2-jwt";
import {
  CalendarModule,
  DataTableModule,
  DropdownModule,
  FileUploadModule,
  GrowlModule,
  TooltipModule,
} from "primeng/primeng";
import { environment } from "../environments/environment";
import { AppComponent } from "./app.component";
import { BypassComponent } from "./modules/bypass/bypass.component";
import { BypassService } from "./modules/bypass/bypass.service";
import { TokenInterceptor } from "./modules/bypass/token.interceptor";
import { ErrorComponent } from "./modules/error/error.component";
import { PersonFormComponent } from "./modules/request/person-form/person-form.component";
import { RequestCommentComponent } from "./modules/request/request-comment/request-comment.component";
import { RequestFilterComponent } from "./modules/request/request-filter/request-filter.component";
import { RequestFormComponent } from "./modules/request/request-form/request-form.component";
import { RequestFormService } from "./modules/request/request-form/request-form.service";
import { RequestHistoryComponent } from "./modules/request/request-history/request-history.component";
import { RequestListComponent } from "./modules/request/request-list/request-list.component";
import { RequestListService } from "./modules/request/request-list/request-list.service";
import { FooterComponent } from "./shared/components/footer/footer.component";
import { HeaderComponent } from "./shared/components/header/header.component";
import { LeftSidebarComponent } from "./shared/components/left-sidebar/left-sidebar.component";
import { KeysPipe } from "./shared/pipes/keys-pipe";
import { AuthGuardService } from "./shared/services/auth-guard.service";

export const ROUTES: Routes = [
  { path: "", component: BypassComponent },
  {
    path: "request-form",
    component: RequestFormComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "request-form/:id",
    component: RequestFormComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "request-list",
    component: RequestListComponent,
    canActivate: [AuthGuardService],
  },
  { path: "error", component: ErrorComponent },
];

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "/assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    BypassComponent,
    RequestFormComponent,
    RequestListComponent,
    HeaderComponent,
    FooterComponent,
    LeftSidebarComponent,
    RequestFilterComponent,
    KeysPipe,
    ErrorComponent,
    RequestHistoryComponent,
    RequestCommentComponent,
    PersonFormComponent,
  ],
  imports: [
    FormsModule,
    CalendarModule,
    FileUploadModule,
    GrowlModule,
    DataTableModule,
    DropdownModule,
    TooltipModule,

    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    RouterModule.forRoot(ROUTES),
  ],
  providers: [
    BypassService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    RequestFormService,
    RequestListService,
    AuthGuardService,
    JwtHelper,
    DatePipe,
    {
      provide: "API_LOGIN",
      useValue: environment.loginUrl,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /app/src/app/app.module.ts